import type { Position } from '@reach/popover';
import {
  positionDefault,
  positionMatchWidth,
  positionRight,
} from '@reach/popover';

import type { PopoverPosition } from '@/types';

export const getPopoverPosition = (position: PopoverPosition): Position => {
  switch (position) {
    case 'default':
      return positionDefault;
    case 'match width':
      return positionMatchWidth;
    case 'right':
      return positionRight;
    case 'up':
      throw new Error('Up position not supported for popovers');
  }
};
